RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const LOADING_VIEW_MESSAGE_TIME = 10000;
    const oauthTokenStates = RivalIQ.enums.oauthTokenStates;

    function getClassNameByState(model) {
        const tokenState = model.tokenState;
        if (tokenState === oauthTokenStates.GOOD_CONNECTION) {
            return 'good-connection';
        } else if (tokenState === oauthTokenStates.BROKEN_CONNECTION) {
            return 'broken-connection';
        } else if (tokenState === oauthTokenStates.INSUFFICIENT_PERMISSION) {
            return 'insufficient-permission-connection';
        }
        return 'unmapped-connection';
    }

    function getTokenStateIcon(tokenState) {
        if (tokenState === oauthTokenStates.GOOD_CONNECTION) {
            return 'fa-check';
        } else if (tokenState === oauthTokenStates.BROKEN_CONNECTION) {
            return 'fa-refresh';
        } else if (tokenState === oauthTokenStates.INSUFFICIENT_PERMISSION) {
            return 'fa-unlink';
        }
        return 'fa-times';
    }

    function getPageName(source, plural) {
        const suffix = (plural ? 's' : '');
        if (source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS) {
            return `Instagram Business Account${suffix}`;
        } else if (source === RivalIQ.enums.sources.FACEBOOK) {
            return `Facebook Page${suffix}`;
        }
        return 'Pages';
    }

    const ConnectedPageName = Marionette.ItemView.extend({
        tagName: 'td',
        template: '#connectedPageNameColumnTemplate',
        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },
        serializeData: function () {
            const me = this;
            const data = me.model.get('data');
            return {
                handle: data.handle,
                icon: getTokenStateIcon(data.tokenState)
            };
        }
    });

    const EmailList = Marionette.ItemView.extend({
        tagName: 'td',
        template: '#emailListColumnTemplate',
        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },
        serializeData: function () {
            const me = this;
            const data = me.model.get('data');
            return {
                emails: data.emails
            };
        }
    });

    const TokenOwnerView = Marionette.ItemView.extend({
        tagName: 'td',
        template: '#tokenOwnerColumnTemplate',
        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },
        serializeData: function () {
            const me = this;
            const data = me.model.get('data');
            return {
                tokenOwner: data.tokenOwner
            };
        }
    });

    function getColumns(source, totalRows) {

        const plural = (totalRows > 1);
        const handleColName = getPageName(source, plural);

        return [
            {
                name: handleColName,
                property: 'handle',
                cellView: ConnectedPageName
            },
            {
                name: 'via Rival IQ User Email',
                property: 'emails',
                cellView: EmailList
            },
            {
                name: 'via Facebook User Name',
                property: 'tokenOwner',
                cellView: TokenOwnerView
            }
        ];
    }

    const ConnectedPagesLoadingView = RivalIQ.views.BlockLoading.extend({
        className: 'panel-loading in connected-pages-loading',

        initialize: function () {
            const me = this;
            me.options.template = '#shellLoadingConnectionsTemplate';
        },

        showMessage: function (text) {
            const me = this;

            if (text) {
                me.ui.message.text(text);
            }
            me.ui.message.addClass('in');
            me.$el.addClass('message-in');
        },

        attributes: {
            style: 'height: 50vh;'
        },

        showForView: function () {
            const me = this;
            me.clearMessage();
            Marionette.Dashboard.views.BlockLoading.prototype.showForView.apply(me, arguments);

            if (me._showingError && me._isRendered) {
                // re-render as showError likely changed $el
                me.render();
                me._showingError = false;
            }

            me.showMessage();

            me.timeout = setTimeout(function () {
                if (me.isDestroyed) {
                    return;
                }

                me.showMessage(`We're still working on it...`);
            }, LOADING_VIEW_MESSAGE_TIME);
        }
    });

    const ConnectedPagesTable = RivalIQ.views.LoadingTableView.mixin({
        LoadingView: ConnectedPagesLoadingView,

        regions: {
            content: '.x-content-region'
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        getTemplate: function () {
            return _.template('<div class="x-content-region"></div>');
        },
        loadData: function () {

            const me = this;
            const source = me.getProp('source');
            const adminModeAccountId = me.getProp('adminModeAccountId');

            if (adminModeAccountId) {

                return $.get(`/api/${adminModeAccountId}/tokensAccess`)
                    .done(function (pages) {
                        me.connectedPages = _.sortBy(pages[source], ['tokenState', 'handle']);
                    });

            } else {

                return $.get(`/api/tokensAccess/${source}`)
                    .done(function (pages) {
                        me.connectedPages = _.sortBy(pages, ['tokenState', 'handle']);
                    });

            }
        },

        onRenderLoaded: function () {
            const me = this;
            const source = me.getProp('source');
            const view = new RivalIQ.views.TableContainer({
                config: {
                    columns: getColumns(source, true),
                    rowClass: getClassNameByState
                },
                model: new Backbone.Model({
                    data: me.connectedPages
                })
            });
            me.content.show(view);
        }
    });

    const ConnectedPagesWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: ConnectedPagesTable,
        viewMore: false
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.CONNECTED_PAGES_TABLE, ConnectedPagesWidget);

    views.ConnectedPagesModal = RivalIQ.views.LayoutView.mixin({

        className: 'modal',
        template: '#connectedPagesModalTemplate',

        attributes: {
            'data-keyboard': false,
            tabindex: '-1'
        },

        regions: {
            pagesTable: '.x-connected-pages-table'
        },

        ui: {
            popovers: '[data-toggle="popover"]'
        },

        onRenderLoaded: function () {
            const me = this;

            const widget = new ConnectedPagesWidget(me.model, {
                props: _.create(me.model.attributes, {
                    source: me.options.source || me.model.get('source')
                })
            });

            me.addRegion('pagesTable', '.x-connected-pages-table');
            me.pagesTable.showWidget(widget, null, {
                forceLoadingView: true
            });
        },

        getLegendItems: function (source, pageNameAbrev) {
            const legendItems = [{
                className: 'good-connection',
                icon: 'fa-check',
                name: 'Connected'
            },
            {
                className: 'broken-connection',
                icon: 'fa-refresh',
                name: 'Reconnection needed'
            }];

            if (source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS) {
                legendItems.push({
                    className: 'broken-connection',
                    icon: 'fa-unlink',
                    name: 'Partially connected (cannot pull all insights for Account)'
                });
            }

            legendItems.push({
                className: 'unmapped-connection',
                icon: 'fa-times',
                name: `${pageNameAbrev} is not connected in your account`
            });

            return legendItems;
        },

        serializeData: function () {
            const me = this;

            const source = me.options.source || me.model.get('source');
            const channel = RivalIQ.enums.sourceDetails[source].channel;
            let helpArticle;
            let pageNameAbrev;

            if (source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS) {
                helpArticle = 'http://help.rivaliq.com/frequently-asked-questions/how-to-connect-instagram-insights-to-rival-iq';
                pageNameAbrev = 'Handle';
            } else {
                helpArticle = 'https://help.rivaliq.com/en/articles/2842114-troubleshooting-facebook-pages-not-connected-to-rival-iq';
                pageNameAbrev = 'Page';
            }
            const legendItems = me.getLegendItems(source, pageNameAbrev);

            return {
                pageName: getPageName(source, true),
                helperMessage: RivalIQ.str(`connected_pages_${channel}_description`, helpArticle),
                legendItems: legendItems
            };
        }
    });
});
